import { render, staticRenderFns } from "./AccreditationPassForm.vue?vue&type=template&id=10204bba&scoped=true&"
import script from "./AccreditationPassForm.vue?vue&type=script&lang=js&"
export * from "./AccreditationPassForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10204bba",
  null
  
)

export default component.exports